import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "HELICOPTER_PILOTAGES",
    applicationRights: Rights,
    title: 'Oppdrag for helikopter',
    text: 'Oppdrag for helikopter',
    icon: 'paper-plane-tilt',
    showOnDashboardByDefault: true,
    url: "/current-helicopter-pilotages",
    sequenceNo: 17600,
    routes: Routes
})
